import React, { useState, useEffect } from 'react';
import '../styles/PWAUpdateNotification.css';

const PWAUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Only run in production
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    // Listen for service worker update
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              setRegistration(reg);
              setShowUpdate(true);
            }
          });
        });
      });

      // Listen for controller change (new SW activated)
      let isRefreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Prevent infinite reload loop
        if (!isRefreshing && !window.location.pathname.includes('offline')) {
          isRefreshing = true;
          window.location.reload();
        }
      });
    }
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      // Tell the waiting service worker to take over
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="pwa-update-notification">
      <div className="pwa-update-content">
        <div className="pwa-update-icon">🎉</div>
        <div className="pwa-update-text">
          <h4>Update Available!</h4>
          <p>A new version of UCMAAPP is ready.</p>
        </div>
        <div className="pwa-update-actions">
          <button className="pwa-update-button" onClick={handleUpdate}>
            Update Now
          </button>
          <button className="pwa-dismiss-button" onClick={handleDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdateNotification;
